import { canMeasure, canMeasureFunnel, canMeasureMarketing } from "./measurement/consent";
const apiBaseUrl = import.meta.env.VITE_API_BASE_URL as string | undefined;
const stripePublishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY as string | undefined;
const enableEmailCaptureFlag = import.meta.env.VITE_ENABLE_EMAIL_CAPTURE as string | undefined;

const parseBooleanFlag = (value: string | undefined, fallback: boolean): boolean => {
  if (!value) {
    return fallback;
  }

  const normalizedValue = value.trim().toLowerCase();
  if (normalizedValue === "true") {
    return true;
  }
  if (normalizedValue === "false") {
    return false;
  }

  return fallback;
};

export const config = {
  apiBaseUrl: new URL(apiBaseUrl ?? "https://api.readparables.com", window.location.origin).href.replace(/\/$/, ""),
  stripePublishableKey: stripePublishableKey ?? "",
  enableEmailCapture: parseBooleanFlag(enableEmailCaptureFlag, true),
  get enableAnalytics() { return canMeasure(); },
  get enableFunnelMetrics() { return canMeasureFunnel(); },
  get enableMarketing() { return canMeasureMarketing(); }
} as const;
